import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Tabs, Tab } from '@material-ui/core';
import './safetynav.scss';

const routes = [
  { label: 'Projects', path: '/safety/projects' },
  { label: 'Daily Forms', path: '/safety/daily-forms' },
  { label: 'Skyclimber', path: '/safety/skyclimber-forms' },
  { label: 'Toolbox Talks', path: '/safety/toolbox-talks' },
  { label: 'Documents', path: '/safety/documents' },
  { label: 'Reports', path: '/safety/reports' },
  { label: 'Config', path: '/safety/config' }
];

const SafetyNav = () => {
  const location = useLocation();
  const currentIndex = routes.findIndex((r) => location.pathname.startsWith(r.path));

  return (
    <div className="safetynav">
      <Tabs value={currentIndex === -1 ? 0 : currentIndex} indicatorColor="primary" textColor="primary">
        {routes.map((route) => (
          <Tab
            key={route.path}
            label={route.label}
            component={Link}
            to={route.path}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default SafetyNav;
